export const categoryKeys = {
	other: "All Servers",
	gaming: "Gaming",
	entertainment: "Entertainment",
	artistsCreators: "Artists & Creators",
	education: "Education",
	scienceTech: "Science & Tech",
	localCommunity: "Loacl & Community"
};
